import styled from '@emotion/styled';
import { SCREEN_MASSIVE } from '../../styles/emotion/mediaQuery';
import { COLORS3, MEDIA_QUERY } from '../../styles/emotion';

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${SCREEN_MASSIVE}px;
  display: grid;

  grid-template-columns: repeat(2, 1fr);

  ${MEDIA_QUERY.TABLET} {
    grid-template-columns: repeat(3, 1fr);
  }
  ${MEDIA_QUERY.DESKTOP} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const GridItem = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  border-left: 1px solid ${COLORS3.BLACK_030};

  // ensure all grid items maintain the same width
  min-width: 0;

  ${MEDIA_QUERY.DESKTOP} {
    &:nth-of-type(4n + 1) {
      border-left: none;
    }
  }

  ${MEDIA_QUERY.TABLET} {
    &:nth-of-type(3n + 1) {
      border-left: none;
    }
  }

  ${MEDIA_QUERY.MOBILE} {
    &:nth-of-type(2n + 1) {
      border-left: none;
    }
  }
`;
